import {FormBodyProps} from "../../../common/props/FormBodyProps";
import * as React from "react";
import SectionView from "../../section/SectionView";
import Row from "../../Row";
import Col from "../../Col";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import HelpContactForm from "./form/HelpContactForm";
import TextAreaFormGroup from "../../../ui/form/TextAreaFormGroup";

type Props = FormBodyProps<HelpContactForm>

/**
 * Individual contact form body.
 */
export default class HelpContactFormBody extends React.Component<Props, {}> {
	render() {
		return <SectionView>
			<Row>
				<Col xl={4}>
					<InputFormGroup label="Name:"
									placeholder="Enter name"
									field={this.props.form.name}
									focus={this.props.form.hasFocus(this.props.form.name)}
									onChange={field => this.props.onFieldChange(field)}
									disabled={true}/>
				</Col>
				<Col xl={4}>
					<InputFormGroup label="Organization:"
									placeholder="Enter organization"
									field={this.props.form.organization}
									focus={this.props.form.hasFocus(this.props.form.organization)}
									onChange={field => this.props.onFieldChange(field)}
									disabled={true}/>
				</Col>
				<Col xl={4}>
					<InputFormGroup label="Email Address:"
									placeholder="Enter email address"
									field={this.props.form.email}
									focus={this.props.form.hasFocus(this.props.form.email)}
									onChange={field => this.props.onFieldChange(field)}
									disabled={true}
									trimRight={true}/>
				</Col>
			</Row>
			<Row>
				<Col>
					<InputFormGroup label="Contact Number:"
									placeholder="Enter contact number"
									field={this.props.form.contactNumber}
									focus={this.props.form.hasFocus(this.props.form.contactNumber)}
									onChange={field => this.props.onFieldChange(field)}/>
					<TextAreaFormGroup label=""
									   rows={5}
									   placeholder="How can we help you?"
									   field={this.props.form.requestText}
									   focus={this.props.form.hasFocus(this.props.form.requestText)}
									   onChange={field => this.props.onFieldChange(field)}/>
				</Col>
			</Row>
		</SectionView>
	}
}